// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3YvOm","paramInput":"JobSimulator_paramInput__3oDiA","input":"JobSimulator_input__1MV1j"};